<svelte:head>
  <title>Offers | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<div class="title">Your offers</div>
<div class="subtitle">Manage the offers you have made.</div>

{#if allItems != undefined}
  {#if allItems.length > 0}
      <table class="table is-fullwidth is-hoverable">
        <tbody>
          {#each allItems as item}
            <tr>
              <td style="width:100%;">
                <div
                  class="is-pulled-left"
                  style="width:60px; height:60px; margin-right:20px;"
                >
                  {#if item.data.images?.[0]}
                    <img
                      src={item.data.images[0]}
                      style="max-height:60px;max-width:60px;"
                    />
                  {:else}
                    <img
                      src="/assets/img/box.png"
                      style="max-height:60px;max-width:60px; background-color:lightgrey"
                    />
                  {/if}
                </div>
                <div
                  class="is-flex is-flex-direction-row align-items is-align-items-center"
                  style="height:60px;"
                >
                  <a href={$url("../../offer/" + item.id)}>{item.data.name || 'Untitled'}</a>
                </div>
              </td>
              <td style="min-width:100px;">
                <div
                  class="is-flex is-flex-direction-row align-items is-align-items-center"
                  style="height:60px;"
                >
                  <span class="tag is-info is-light"
                    >{item.data.status}</span
                  >
                </div>
              </td>
              <td style="min-width:100px;">
                <div
                  class="is-flex is-flex-direction-row align-items is-align-items-center"
                  style="height:60px;"
                >
                {#if item.data.requests && item.data.requests.length > 0}
                  <span class="tag is-success is-light">
                    {`Request${item.data.requests.length > 1 ? 's' : ''} made${item.data.requests.length > 1 ? ` (${item.data.requests.length})` : ''}`}
                  </span>
                {/if}
                </div>
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
  {:else}
    <article class="message is-success">
      <div class="message-body">
        You have not made any offers yet.
        <a on:click={createOffer}>Create your first one</a>.
      </div>
    </article>
  {/if}
{/if}

<script lang="ts">
  import _ from "lodash";
  import { appState } from "../../../lib/appState";
  import { uiState } from "../../../lib/uiState";
  import { url, goto } from "@sveltech/routify";
  import { hasActiveSubscription } from '../../../lib/subscriptionHelper';
  import Premium from "./_components/Premium.svelte";

  let allItems: Offer_v2_Doc[];

  let firebase = window.firebase;

  get();

  async function get() {
    firebase
      .firestore()
      .collection("offers_v2")
      .where("company", "==", $appState.user!.company)
      .onSnapshot((snap) => {
        allItems = snap.docs.map( doc => ({ id: doc.id, data: doc.data() as Offer_v2 })).sort((a,b) => b.data.created > a.data.created ? 1 : -1);
      });
  }

  function createOffer() {
    if(hasActiveSubscription($appState.company)) {
      $goto('/business/offers/create');
    }
    else {
      $uiState.activeModal = { 
            component: Premium,
            props: {}
        };
    }
  }  
</script>
